import React from "react";
import {
  ContactContainer,
  ContactFormContainer,
  ContactImaContainer,
  ContactWrapper,
  FormColumnRight,
  FormColumnLeft,
  FormWrapper,
  TitleContainer,
  TextContainer,
  ButtonContainer,
  Button,
} from "./index.styled";
import { Container } from "../../pages/AvaNegarLanding/index.styled";
import contactImg from "../../assets/images/contacts.svg";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import FormikControl from "../../components/form/formikControl";
import { FormContainer } from "../../components/form/alignment";
import { postContactUs } from "../../services/cantactUsAPI";
import { CustomButton } from "../buttons/index.styled";
import { toast } from "react-toastify";

const ContactWithUs = () => {
  const initialValues = {
    phoneNumber: "",
    nickname: "",
    description: "",
    email: "",
  };

  const validationSchema = Yup.object({
    phoneNumber: Yup.number()
      .required("شماره تلفن الزامی می‌باشد")
      .typeError("شماره تلفن نباید کاراکتر باشد"),
    email: Yup.string()
      .email("ایمیل نامعتبر است.")
      .required("ایمیل الزامی می باشد."),
    description: Yup.string().required("توضیحات الزامی است"),
    nickname: Yup.string().required("نام الزامی است"),
  });

  const onSubmit = async (values, { resetForm }) => {
    const obj = {
      fullName: values.nickname,
      mobile: values.phoneNumber,
      email: values.email,
      text: values.description,
    };

    const response = await postContactUs(obj);

    if (response.type) {
      toast.success("درخواست شما با موفقیت ارسال شد.");
      resetForm();
    } else {
      toast.error(response.message);
    }
  };

  return (
    <ContactWrapper>
      <Container>
        <ContactContainer id="contacts">
          <ContactImaContainer>
            <img src={contactImg} alt="contact" />
          </ContactImaContainer>
          <ContactFormContainer>
            <TitleContainer
              color="#12A46F"
              titleColor="#8C8D9B"
              textColor="#2D3134"
            >
              <h5>تماس با ما</h5>
              <TextContainer width="708px" height="56px">
                <span></span>
                <p style={{ marginRight: "10px" }}>
                  برای اطلاعات بیشتر فرم زیر را تکمیل کنید.
                </p>
              </TextContainer>
            </TitleContainer>

            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {(formik) => {
                return (
                  <FormContainer>
                    <Form>
                      <FormWrapper>
                        <FormColumnRight>
                          <FormikControl
                            control="input"
                            name="nickname"
                            type="text"
                            placeholder="نام و نام خانوادگی"
                            // width="300px"
                            // height="48px"
                            // minHeight="90px"
                            marginBottom="20px"
                            borderColor="transparent"
                          />
                          <FormikControl
                            control="input"
                            name="email"
                            placeholder="ایمیل"
                            // width="300px"
                            // height="48px"
                            // minHeight="90px"
                            marginBottom="20px"
                            borderColor="transparent"
                          />
                          <FormikControl
                            control="input"
                            name="phoneNumber"
                            placeholder="شماره تماس"
                            // width="300px"
                            // height="48px"
                            // minHeight="85px"
                            borderColor="transparent"
                          />
                        </FormColumnRight>
                        <FormColumnLeft>
                          <FormikControl
                            control="textarea"
                            name="description"
                            placeholder="متن پیام"
                            width="340px"
                            height="116px"
                            // minHeight="240px"
                            marginBottom="20px"
                            borderColor="transparent"
                          />
                          <ButtonContainer>
                            <Button
                              type="submit"
                              disabled={!formik.isValid}
                              width="340px"
                              height="48px"
                              background="#12A46F"
                              borderColor="#12A46F"
                              colorHover="#12A46F"
                              backgroundHover="#FFFFFF"
                              borderColorHover="#12A46F"
                            >
                              ارسال
                            </Button>
                          </ButtonContainer>
                        </FormColumnLeft>
                      </FormWrapper>
                    </Form>
                  </FormContainer>
                );
              }}
            </Formik>
          </ContactFormContainer>
        </ContactContainer>
      </Container>
    </ContactWrapper>
  );
};

export default ContactWithUs;
